import React from 'react';
import PropTypes from 'prop-types';

import { Section } from '../../../../library/page/page';
import NearestStores from '../nearest-stores/nearest-stores';

import { GET_NEARBY_STORES } from '../../graphql/store-detail-queries';

import { useQuery } from '../../../../shared/hooks/hooks';

import { LocationProp } from '../../../../shared/utils/prop-types/prop-types';

function MoreStores(props) {
  const { isMyStore, location, nearByMapWidth, storeCode, storeType } = props;
  const { data = {} } = useQuery(GET_NEARBY_STORES, {
    variables: {
      storeCode
    }
  });
  const nearByStores = data?.store?.nearByStores;

  if (!Array.isArray(nearByStores) || nearByStores.length <= 0) {
    return null;
  }

  return (
    <Section
      heading="More Stores Near This Store"
      intro={
        <p className="nearest-intro">
          The nearest {storeType} Tire store is{' '}
          <strong>{nearByStores[0]?.distance || ''}</strong> miles from this
          store.
        </p>
      }
      isFullWidth
      showDivider
    >
      <NearestStores
        centerPos={location}
        isMyStore={isMyStore}
        mapHeight={800}
        mapWidth={nearByMapWidth}
        stores={nearByStores}
      />
    </Section>
  );
}

MoreStores.propTypes = {
  isMyStore: PropTypes.bool.isRequired,
  location: LocationProp.isRequired,
  nearByMapWidth: PropTypes.number.isRequired,
  storeCode: PropTypes.string.isRequired,
  storeType: PropTypes.string.isRequired
};

export default MoreStores;
